// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export function namespaceToJson(m) {
    const o = {};
    if (m.namespace !== undefined) {
        if (m.namespace.type === 'accountGroupNamespace') {
            o['accountGroupNamespace'] = namespaceAccountGroupNamespaceToJson(m.namespace.accountGroupNamespace);
        }
        if (m.namespace.type === 'partnerNamespace') {
            o['partnerNamespace'] = namespacePartnerNamespaceToJson(m.namespace.partnerNamespace);
        }
        if (m.namespace.type === 'systemNamespace') {
            o['systemNamespace'] = namespaceSystemNamespaceToJson(m.namespace.systemNamespace);
        }
    }
    else {
        if (m.accountGroupNamespace !== undefined)
            o['accountGroupNamespace'] = namespaceAccountGroupNamespaceToJson(m.accountGroupNamespace);
        if (m.partnerNamespace !== undefined)
            o['partnerNamespace'] = namespacePartnerNamespaceToJson(m.partnerNamespace);
        if (m.systemNamespace !== undefined)
            o['systemNamespace'] = namespaceSystemNamespaceToJson(m.systemNamespace);
    }
    return o;
}
export function namespaceFromJson(o) {
    return {
        namespace: (() => {
            if (o['accountGroupNamespace'] !== undefined)
                return { type: 'accountGroupNamespace', accountGroupNamespace: o['accountGroupNamespace'] ? namespaceAccountGroupNamespaceFromJson(o['accountGroupNamespace']) : undefined };
            if (o['partnerNamespace'] !== undefined)
                return { type: 'partnerNamespace', partnerNamespace: o['partnerNamespace'] ? namespacePartnerNamespaceFromJson(o['partnerNamespace']) : undefined };
            if (o['systemNamespace'] !== undefined)
                return { type: 'systemNamespace', systemNamespace: o['systemNamespace'] ? namespaceSystemNamespaceFromJson(o['systemNamespace']) : undefined };
            return undefined;
        })(),
        accountGroupNamespace: o['accountGroupNamespace'] !== undefined ? o['accountGroupNamespace'] ? namespaceAccountGroupNamespaceFromJson(o['accountGroupNamespace']) : undefined : undefined,
        partnerNamespace: o['partnerNamespace'] !== undefined ? o['partnerNamespace'] ? namespacePartnerNamespaceFromJson(o['partnerNamespace']) : undefined : undefined,
        systemNamespace: o['systemNamespace'] !== undefined ? o['systemNamespace'] ? namespaceSystemNamespaceFromJson(o['systemNamespace']) : undefined : undefined,
    };
}
export function namespaceAccountGroupNamespaceToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function namespaceAccountGroupNamespaceFromJson(o) {
    var _a;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function namespacePartnerNamespaceToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function namespacePartnerNamespaceFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function namespaceSystemNamespaceToJson(m) {
    const o = {};
    return o;
}
export function namespaceSystemNamespaceFromJson(o) {
    return {};
}
export function callRecordToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deleted !== undefined)
        o['deleted'] = m.deleted.toISOString();
    if (m.transcript !== undefined) {
        o['transcript'] = m.transcript.map(e => transcriptMessageToJson(e));
    }
    if (m.audioRecordingUrl !== undefined)
        o['audioRecordingUrl'] = m.audioRecordingUrl;
    if (m.callType !== undefined)
        o['callType'] = m.callType;
    if (m.fromPhoneNumber !== undefined)
        o['fromPhoneNumber'] = m.fromPhoneNumber;
    if (m.toPhoneNumber !== undefined)
        o['toPhoneNumber'] = m.toPhoneNumber;
    if (m.callDuration !== undefined)
        o['callDuration'] = m.callDuration;
    if (m.metadata !== undefined)
        o['metadata'] = metadataToJson(m.metadata);
    if (m.callSource !== undefined)
        o['callSource'] = m.callSource;
    if (m.callerUserId !== undefined)
        o['callerUserId'] = m.callerUserId;
    if (m.terminationCause !== undefined)
        o['terminationCause'] = m.terminationCause;
    return o;
}
export function callRecordFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deleted: o['deleted'] ? new Date(o['deleted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        transcript: ((_b = o['transcript']) !== null && _b !== void 0 ? _b : []).map(e => transcriptMessageFromJson(e)),
        audioRecordingUrl: (_c = o['audioRecordingUrl']) !== null && _c !== void 0 ? _c : '',
        callType: (_d = o['callType']) !== null && _d !== void 0 ? _d : 'CALL_TYPE_INVALID',
        fromPhoneNumber: (_e = o['fromPhoneNumber']) !== null && _e !== void 0 ? _e : '',
        toPhoneNumber: (_f = o['toPhoneNumber']) !== null && _f !== void 0 ? _f : '',
        callDuration: (_g = o['callDuration']) !== null && _g !== void 0 ? _g : 0,
        metadata: o['metadata'] ? metadataFromJson(o['metadata']) : undefined,
        callSource: (_h = o['callSource']) !== null && _h !== void 0 ? _h : 'CALL_SOURCE_INVALID',
        callerUserId: (_j = o['callerUserId']) !== null && _j !== void 0 ? _j : '',
        terminationCause: (_k = o['terminationCause']) !== null && _k !== void 0 ? _k : 'TERMINATION_CAUSE_INVALID',
    };
}
export function metadataToJson(m) {
    const o = {};
    if (m.voiceConfig !== undefined)
        o['voiceConfig'] = voiceConfigToJson(m.voiceConfig);
    if (m.assistantId !== undefined)
        o['assistantId'] = m.assistantId;
    if (m.functionCalls !== undefined) {
        o['functionCalls'] = m.functionCalls.map(e => functionCallToJson(e));
    }
    return o;
}
export function metadataFromJson(o) {
    var _a, _b;
    return {
        voiceConfig: o['voiceConfig'] ? voiceConfigFromJson(o['voiceConfig']) : undefined,
        assistantId: (_a = o['assistantId']) !== null && _a !== void 0 ? _a : '',
        functionCalls: ((_b = o['functionCalls']) !== null && _b !== void 0 ? _b : []).map(e => functionCallFromJson(e)),
    };
}
export function transcriptMessageToJson(m) {
    const o = {};
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.itemId !== undefined)
        o['itemId'] = m.itemId;
    if (m.participant !== undefined)
        o['participant'] = m.participant;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    return o;
}
export function transcriptMessageFromJson(o) {
    var _a, _b, _c;
    return {
        content: (_a = o['content']) !== null && _a !== void 0 ? _a : '',
        itemId: (_b = o['itemId']) !== null && _b !== void 0 ? _b : '',
        participant: (_c = o['participant']) !== null && _c !== void 0 ? _c : 'PARTICIPANT_INVALID',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function voiceConfigToJson(m) {
    const o = {};
    if (m.vendorModel !== undefined)
        o['vendorModel'] = m.vendorModel;
    if (m.modelConfig !== undefined) {
        if (m.modelConfig.type === 'openaiRealtimeConfig') {
            o['openaiRealtimeConfig'] = openAIRealtimeConfigToJson(m.modelConfig.openaiRealtimeConfig);
        }
        if (m.modelConfig.type === 'deepgramConfig') {
            o['deepgramConfig'] = deepgramConfigToJson(m.modelConfig.deepgramConfig);
        }
    }
    else {
        if (m.openaiRealtimeConfig !== undefined)
            o['openaiRealtimeConfig'] = openAIRealtimeConfigToJson(m.openaiRealtimeConfig);
        if (m.deepgramConfig !== undefined)
            o['deepgramConfig'] = deepgramConfigToJson(m.deepgramConfig);
    }
    return o;
}
export function voiceConfigFromJson(o) {
    var _a;
    return {
        vendorModel: (_a = o['vendorModel']) !== null && _a !== void 0 ? _a : 'VENDOR_MODEL_UNSPECIFIED',
        modelConfig: (() => {
            if (o['openaiRealtimeConfig'] !== undefined)
                return { type: 'openaiRealtimeConfig', openaiRealtimeConfig: o['openaiRealtimeConfig'] ? openAIRealtimeConfigFromJson(o['openaiRealtimeConfig']) : undefined };
            if (o['deepgramConfig'] !== undefined)
                return { type: 'deepgramConfig', deepgramConfig: o['deepgramConfig'] ? deepgramConfigFromJson(o['deepgramConfig']) : undefined };
            return undefined;
        })(),
        openaiRealtimeConfig: o['openaiRealtimeConfig'] !== undefined ? o['openaiRealtimeConfig'] ? openAIRealtimeConfigFromJson(o['openaiRealtimeConfig']) : undefined : undefined,
        deepgramConfig: o['deepgramConfig'] !== undefined ? o['deepgramConfig'] ? deepgramConfigFromJson(o['deepgramConfig']) : undefined : undefined,
    };
}
export function openAIRealtimeConfigToJson(m) {
    const o = {};
    if (m.voice !== undefined)
        o['voice'] = m.voice;
    if (m.turnDetection !== undefined)
        o['turnDetection'] = openAIRealtimeConfigTurnDetectionToJson(m.turnDetection);
    return o;
}
export function openAIRealtimeConfigFromJson(o) {
    var _a;
    return {
        voice: (_a = o['voice']) !== null && _a !== void 0 ? _a : '',
        turnDetection: o['turnDetection'] ? openAIRealtimeConfigTurnDetectionFromJson(o['turnDetection']) : undefined,
    };
}
export function openAIRealtimeConfigTurnDetectionToJson(m) {
    const o = {};
    if (m.threshold !== undefined)
        o['threshold'] = m.threshold;
    if (m.prefixPadding !== undefined)
        o['prefixPadding'] = m.prefixPadding;
    if (m.silenceDuration !== undefined)
        o['silenceDuration'] = m.silenceDuration;
    return o;
}
export function openAIRealtimeConfigTurnDetectionFromJson(o) {
    var _a, _b, _c;
    return {
        threshold: (_a = o['threshold']) !== null && _a !== void 0 ? _a : 0,
        prefixPadding: (_b = o['prefixPadding']) !== null && _b !== void 0 ? _b : 0,
        silenceDuration: (_c = o['silenceDuration']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function deepgramConfigToJson(m) {
    const o = {};
    if (m.voice !== undefined)
        o['voice'] = m.voice;
    return o;
}
export function deepgramConfigFromJson(o) {
    var _a;
    return {
        voice: (_a = o['voice']) !== null && _a !== void 0 ? _a : '',
    };
}
export function keyValuePairToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function keyValuePairFromJson(o) {
    var _a, _b;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function functionCallToJson(m) {
    const o = {};
    if (m.functionId !== undefined)
        o['functionId'] = m.functionId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.arguments !== undefined)
        o['arguments'] = m.arguments;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    if (m.calledAt !== undefined)
        o['calledAt'] = m.calledAt.toISOString();
    if (m.response !== undefined)
        o['response'] = m.response;
    return o;
}
export function functionCallFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        functionId: (_a = o['functionId']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        arguments: (_c = o['arguments']) !== null && _c !== void 0 ? _c : '',
        metadata: ((_d = o['metadata']) !== null && _d !== void 0 ? _d : []).map(e => keyValuePairFromJson(e)),
        calledAt: o['calledAt'] ? new Date(o['calledAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        response: (_e = o['response']) !== null && _e !== void 0 ? _e : '',
    };
}
export function getCallRecordRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function getCallRecordRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function getCallRecordResponseToJson(m) {
    const o = {};
    if (m.callRecord !== undefined)
        o['callRecord'] = callRecordToJson(m.callRecord);
    return o;
}
export function getCallRecordResponseFromJson(o) {
    return {
        callRecord: o['callRecord'] ? callRecordFromJson(o['callRecord']) : undefined,
    };
}
export function deleteCallRecordRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function deleteCallRecordRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function getCallUsageRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function getCallUsageRequestFromJson(o) {
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function getCallUsageResponseToJson(m) {
    const o = {};
    if (m.startTime !== undefined)
        o['startTime'] = m.startTime.toISOString();
    if (m.endTime !== undefined)
        o['endTime'] = m.endTime.toISOString();
    if (m.totalDuration !== undefined)
        o['totalDuration'] = m.totalDuration;
    return o;
}
export function getCallUsageResponseFromJson(o) {
    var _a;
    return {
        startTime: o['startTime'] ? new Date(o['startTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        endTime: o['endTime'] ? new Date(o['endTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        totalDuration: (_a = o['totalDuration']) !== null && _a !== void 0 ? _a : 0,
    };
}
export function voiceNoteTranscriptToJson(m) {
    const o = {};
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.start !== undefined)
        o['start'] = m.start;
    if (m.end !== undefined)
        o['end'] = m.end;
    if (m.confidence !== undefined)
        o['confidence'] = m.confidence;
    if (m.speakerId !== undefined)
        o['speakerId'] = m.speakerId;
    return o;
}
export function voiceNoteTranscriptFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        content: (_a = o['content']) !== null && _a !== void 0 ? _a : '',
        start: (_b = o['start']) !== null && _b !== void 0 ? _b : 0,
        end: (_c = o['end']) !== null && _c !== void 0 ? _c : 0,
        confidence: (_d = o['confidence']) !== null && _d !== void 0 ? _d : 0,
        speakerId: (_e = o['speakerId']) !== null && _e !== void 0 ? _e : '',
    };
}
export function asyncAudioURLToJson(m) {
    const o = {};
    if (m.audioUrl !== undefined)
        o['audioUrl'] = m.audioUrl;
    if (m.correlationId !== undefined)
        o['correlationId'] = m.correlationId;
    return o;
}
export function asyncAudioURLFromJson(o) {
    var _a, _b;
    return {
        audioUrl: (_a = o['audioUrl']) !== null && _a !== void 0 ? _a : '',
        correlationId: (_b = o['correlationId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function makeOutboundCallRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.toPhoneNumber !== undefined)
        o['toPhoneNumber'] = m.toPhoneNumber;
    if (m.callContext !== undefined)
        o['callContext'] = m.callContext;
    if (m.assistantId !== undefined)
        o['assistantId'] = m.assistantId;
    return o;
}
export function makeOutboundCallRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        toPhoneNumber: (_a = o['toPhoneNumber']) !== null && _a !== void 0 ? _a : '',
        callContext: (_b = o['callContext']) !== null && _b !== void 0 ? _b : '',
        assistantId: (_c = o['assistantId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function makeOutboundCallResponseToJson(m) {
    const o = {};
    if (m.callSid !== undefined)
        o['callSid'] = m.callSid;
    return o;
}
export function makeOutboundCallResponseFromJson(o) {
    var _a;
    return {
        callSid: (_a = o['callSid']) !== null && _a !== void 0 ? _a : '',
    };
}
export function transcribeAudioRequestToJson(m) {
    const o = {};
    if (m.audio !== undefined)
        o['audio'] = m.audio;
    if (m.contentType !== undefined)
        o['contentType'] = m.contentType;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.diarize !== undefined)
        o['diarize'] = m.diarize;
    if (m.audioSource !== undefined) {
        if (m.audioSource.type === 'asyncAudioUrl') {
            o['asyncAudioUrl'] = asyncAudioURLToJson(m.audioSource.asyncAudioUrl);
        }
        if (m.audioSource.type === 'audioBytes') {
            o['audioBytes'] = m.audioSource.audioBytes;
        }
    }
    else {
        if (m.asyncAudioUrl !== undefined)
            o['asyncAudioUrl'] = asyncAudioURLToJson(m.asyncAudioUrl);
        if (m.audioBytes !== undefined)
            o['audioBytes'] = m.audioBytes;
    }
    return o;
}
export function transcribeAudioRequestFromJson(o) {
    var _a, _b, _c;
    return {
        audio: (_a = o['audio']) !== null && _a !== void 0 ? _a : '',
        contentType: (_b = o['contentType']) !== null && _b !== void 0 ? _b : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        diarize: (_c = o['diarize']) !== null && _c !== void 0 ? _c : false,
        audioSource: (() => {
            if (o['asyncAudioUrl'] !== undefined)
                return { type: 'asyncAudioUrl', asyncAudioUrl: o['asyncAudioUrl'] ? asyncAudioURLFromJson(o['asyncAudioUrl']) : undefined };
            if (o['audioBytes'] !== undefined)
                return { type: 'audioBytes', audioBytes: o['audioBytes'] };
            return undefined;
        })(),
        asyncAudioUrl: o['asyncAudioUrl'] !== undefined ? o['asyncAudioUrl'] ? asyncAudioURLFromJson(o['asyncAudioUrl']) : undefined : undefined,
        audioBytes: o['audioBytes'] !== undefined ? o['audioBytes'] : undefined,
    };
}
export function transcribeAudioSyncResultToJson(m) {
    const o = {};
    if (m.segments !== undefined) {
        o['segments'] = m.segments.map(e => voiceNoteTranscriptToJson(e));
    }
    return o;
}
export function transcribeAudioSyncResultFromJson(o) {
    var _a;
    return {
        segments: ((_a = o['segments']) !== null && _a !== void 0 ? _a : []).map(e => voiceNoteTranscriptFromJson(e)),
    };
}
export function transcribeAudioResponseToJson(m) {
    const o = {};
    if (m.segments !== undefined) {
        o['segments'] = m.segments.map(e => voiceNoteTranscriptToJson(e));
    }
    if (m.result !== undefined) {
        if (m.result.type === 'transcription') {
            o['transcription'] = transcribeAudioSyncResultToJson(m.result.transcription);
        }
        if (m.result.type === 'jobId') {
            o['jobId'] = m.result.jobId;
        }
    }
    else {
        if (m.transcription !== undefined)
            o['transcription'] = transcribeAudioSyncResultToJson(m.transcription);
        if (m.jobId !== undefined)
            o['jobId'] = m.jobId;
    }
    return o;
}
export function transcribeAudioResponseFromJson(o) {
    var _a;
    return {
        segments: ((_a = o['segments']) !== null && _a !== void 0 ? _a : []).map(e => voiceNoteTranscriptFromJson(e)),
        result: (() => {
            if (o['transcription'] !== undefined)
                return { type: 'transcription', transcription: o['transcription'] ? transcribeAudioSyncResultFromJson(o['transcription']) : undefined };
            if (o['jobId'] !== undefined)
                return { type: 'jobId', jobId: o['jobId'] };
            return undefined;
        })(),
        transcription: o['transcription'] !== undefined ? o['transcription'] ? transcribeAudioSyncResultFromJson(o['transcription']) : undefined : undefined,
        jobId: o['jobId'] !== undefined ? o['jobId'] : undefined,
    };
}
